import useInvalidateResources from 'hooks/useInvalidateResources';
import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { BankTransactionsCacheKeys } from 'types/cacheKeys.types';
import { World } from 'types/shared/worlds';

const useInvalidateTransferDependencies = () => {
  const invalidateResources = useInvalidateResources();

  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries(
      BankTransactionsCacheKeys.CashAvailableFactors,
    );

    queryClient.invalidateQueries(BankTransactionsCacheKeys.Connectors);

    queryClient.invalidateQueries(BankTransactionsCacheKeys.SettingsConnectors);

    queryClient.invalidateQueries(BankTransactionsCacheKeys.TransactionsList);

    invalidateResources(World.BANK);
  }, [invalidateResources, queryClient]);
};

export default useInvalidateTransferDependencies;
